export const WEBSITE_API = '/api/dashboard/website'
